<template>
    <div>
        <div class="flex">
            <p class="w-320 font-semibold my-4">{{ $t('multi-posting.campaigns.filters.job_function') }}</p>
            <p>{{ jobFunction }}</p>
        </div>
        <div class="flex">
            <p class="w-320 font-semibold my-4">{{ $t('multi-posting.campaigns.filters.education') }}</p>
            <p>{{ educationLevel }}</p>
        </div>
        <div class="flex">
            <p class="w-320 font-semibold my-4">{{ $t('multi-posting.campaigns.filters.seniority') }}</p>
            <p>{{ seniority }}</p>
        </div>
        <div class="flex">
            <p class="w-320 font-semibold my-4">{{ $t('multi-posting.campaigns.filters.industry') }}</p>
            <p>{{ industry }}</p>
        </div>
    </div>
</template>
<script>
import {mapState} from "pinia";
import {useMultiPostingStore} from "../../../state/modules/multiPosting";

export default {
    name: "TargetGroup",
    computed: {
        ...mapState(useMultiPostingStore, ['form', 'lookups']),
        jobFunction() {
            if (this.form.jobFunctionName) {
                return this.form.jobFunctionName
            }
            return this.lookups.jobFunctions.find(x => x.value === this.form.jobFunctionId)?.label;
        },
        educationLevel() {
            if (this.form.educationLevelName) {
                return this.form.educationLevelName
            }
            return this.lookups.educationLevels.find(x => x.value === this.form.educationLevelId)?.label;
        },
        seniority() {
            if (this.form.seniorityName) {
                return this.form.seniorityName
            }
            return this.lookups.seniority.find(x => x.value === this.form.seniorityId)?.label;
        },
        industry() {
            if (this.form.industryName) {
                return this.form.industryName
            }
            return this.lookups.industries.find(x => x.value === this.form.industryId)?.label;
        },
    }
}
</script>
<style scoped>

</style>